/**
 * HushAlign bundle + colour picker.
 * Variant = pack (option1) x colour (option2). Every picker on the page (hero, bundle
 * section, final CTA) stays in sync, as do all ATC forms, prices, the sticky bar and the URL.
 *
 * Contract:
 *  script[data-hs-variants]        [{id, pack, color, qty, available, price, compareAt, unit, save, mediaIndex, image}]
 *  [data-hs-picker]                picker root (any number)
 *    [data-hs-pack] > input[radio] pack cards, [data-hs-card-price|unit|compare|save]
 *    [data-hs-color]               colour buttons, [data-hs-color-label]
 *  input[data-rx-variant-input]    hidden id in every ATC form (relyxi-home-atc snippet)
 *  [data-rx-price] / [data-rx-compare] / [data-rx-sticky-image]
 *  [data-hs-save-line]             optional "You save X" text
 */
if (!window.__hsBound) {
  window.__hsBound = true;

  const variants = (() => {
    try {
      return JSON.parse(document.querySelector('script[data-hs-variants]')?.textContent || '[]');
    } catch (_) {
      return [];
    }
  })();

  const state = { pack: null, color: null };
  const find = (pack, color) => variants.find((v) => v.pack === pack && v.color === color);

  const scrollGalleryTo = (index) => {
    const track = document.querySelector('[data-rx-gallery-track]');
    if (!track || index == null || index < 0) return;
    const slide = track.children[index];
    if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  };

  const render = ({ scroll = false, updateUrl = true } = {}) => {
    const v = find(state.pack, state.color);
    if (!v) return;

    document.querySelectorAll('input[data-rx-variant-input]').forEach((i) => (i.value = v.id));
    document.querySelectorAll('[data-rx-price]').forEach((el) => (el.textContent = v.price));
    document.querySelectorAll('[data-rx-compare]').forEach((el) => {
      el.textContent = v.compareAt || '';
      el.hidden = !v.compareAt;
    });
    document.querySelectorAll('[data-hs-save-line]').forEach((el) => {
      el.hidden = !v.save;
      const out = el.querySelector('[data-hs-save]');
      if (out) out.textContent = v.save || '';
    });
    document.querySelectorAll('[data-rx-sticky-image]').forEach((img) => {
      if (v.image) img.src = v.image;
    });
    document.querySelectorAll('[data-hs-sticky-pack]').forEach((el) => (el.textContent = v.pack));
    document.querySelectorAll('form[data-rx-atc] button[type="submit"]').forEach((b) => (b.disabled = v.available === false));

    // Cards: pack state + prices for the current colour
    document.querySelectorAll('[data-hs-pack]').forEach((card) => {
      const on = card.dataset.hsPack === state.pack;
      card.classList.toggle('is-active', on);
      const radio = card.querySelector('input');
      if (radio) radio.checked = on;
      const cv = find(card.dataset.hsPack, state.color);
      if (!cv) return;
      const set = (sel, val) => card.querySelectorAll(sel).forEach((el) => (el.textContent = val || ''));
      set('[data-hs-card-price]', cv.price);
      set('[data-hs-card-unit]', cv.unit);
      set('[data-hs-card-compare]', cv.compareAt);
      set('[data-hs-card-save]', cv.save);
    });

    document.querySelectorAll('[data-hs-color]').forEach((b) => {
      const on = b.dataset.hsColor === state.color;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-hs-color-label]').forEach((el) => (el.textContent = state.color));

    if (scroll) scrollGalleryTo(v.mediaIndex);

    // Only write ?variant= after the visitor changes pack/colour, never on page load,
    // so the homepage URL stays clean (ads, analytics, sharing).
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
  };

  document.addEventListener('change', (e) => {
    const card = e.target.closest?.('[data-hs-pack]');
    if (!card) return;
    state.pack = card.dataset.hsPack;
    render();
  });

  document.addEventListener('click', (e) => {
    const card = e.target.closest?.('[data-hs-pack]');
    if (card && e.target.tagName !== 'INPUT') {
      state.pack = card.dataset.hsPack;
      render();
      return;
    }
    const color = e.target.closest?.('[data-hs-color]');
    if (color) {
      state.color = color.dataset.hsColor;
      render({ scroll: true });
    }
  });

  const init = () => {
    if (!variants.length) return;
    const fromUrl = new URLSearchParams(window.location.search).get('variant');
    const initial =
      variants.find((v) => String(v.id) === String(fromUrl)) ||
      (() => {
        const active = document.querySelector('[data-hs-pack].is-active');
        const color = document.querySelector('[data-hs-color].is-active');
        return find(active?.dataset.hsPack, color?.dataset.hsColor || variants[0].color);
      })() ||
      variants[0];
    state.pack = initial.pack;
    state.color = initial.color;
    render({ updateUrl: false });
  };

  init();
}
